import { FunctionComponent } from 'react';
import Countdown, { CountdownProps } from 'react-countdown';

interface UpcomingEventCountdownProps extends Omit<CountdownProps, 'renderer'> {
  omitSecondsWhenIsDaysAway?: boolean;
}

const UpcomingEventCountdown: FunctionComponent<UpcomingEventCountdownProps> = ({
  omitSecondsWhenIsDaysAway,
  ...props
}) => {
  return (
    <Countdown
      renderer={({ formatted, days }) => {
        const { hours, minutes, seconds } = formatted;

        const isDaysAway = days > 0;

        return (
          <span>
            {isDaysAway && `${days}d `}
            {`${hours}h ${minutes}m `}
            {((isDaysAway && !omitSecondsWhenIsDaysAway) || !isDaysAway) && `${seconds}s`}
          </span>
        );
      }}
      {...props}
    />
  );
};

export { UpcomingEventCountdown, type UpcomingEventCountdownProps };
